module.exports = __webpack_public_path__ + "static/img/pure-pavo.cbe656c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/pure-pavo.png
// module id = 226
// module chunks = 1